import Axios, {
  AxiosStatic,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosError,
} from 'axios';

let AXIOS_INSTANCE: AxiosStatic | AxiosInstance = Axios;

export const configureAxios = (config?: AxiosRequestConfig) => {
  AXIOS_INSTANCE = Axios.create(config);

  return AXIOS_INSTANCE;
};

export const getAxiosInstance = () => AXIOS_INSTANCE;

export const instance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const source = Axios.CancelToken.source();
  const promise = AXIOS_INSTANCE<T>({
    ...config,
    ...options,
    paramsSerializer: {
      indexes: null,
    },
    cancelToken: source.token,
  }).then(({ data }) => data);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  promise.cancel = () => {
    source.cancel('Query was cancelled');
  };

  return promise;
};

// In some case with react-query and swr you want to be able to override the return error type so you can also do it here like this
export type ErrorType<Error> = AxiosError<Error>;

export type BodyType<BodyData> = BodyData;
